import { Http } from 'angular2/http';
import { Injectable } from 'angular2/core';

@Injectable()
export class WeeklyService {
  weeks;

  constructor(public http: Http) {
    this.weeks = [];
    this.retrieveCurrent();
  }

  retrieveCurrent() {
    if(this.weeks.length == 0) {
      // this.http.get('mock.json')
      //this.http.get('file:///android_asset/www/mock.json')
      this.http.get('https://www.ocgracefirst.com/wp-json/llch/v2/weekly/current/last/3')
          .subscribe(data => {
            var weeks = data.json();
            var week;
            while(week = weeks.shift()){
              this.weeks.push(week);
            }
          });
    }
  }

  getWeeks() {
    return this.weeks;
  }
}